import React from 'react';

type Props = {
  open: boolean;
  title?: string;
  message: string;
  onClose: () => void;
  /** 'error' for red accent; 'success' for green; default neutral */
  variant?: 'error' | 'success' | 'info';
};

const AlertModal: React.FC<Props> = ({
  open,
  title = 'Notice',
  message,
  onClose,
  variant = 'info',
}) => {
  if (!open) return null;

  const headerStyle =
    variant === 'error'
      ? { borderTop: '4px solid #b91c1c' }
      : variant === 'success'
        ? { borderTop: '4px solid #15803d' }
        : undefined;

  return (
    <div className="zivo-global-modal-overlay" onClick={onClose} role="presentation">
      <div
        className="zivo-global-modal-content"
        role="dialog"
        aria-modal="true"
        aria-label={title}
        onClick={(e) => e.stopPropagation()}
        style={headerStyle}
      >
        <div className="zivo-global-modal-header">
          <h3>{title}</h3>
        </div>
        <div className="zivo-global-modal-body">
          <p>{message}</p>
        </div>
        <div className="zivo-global-modal-footer" style={{ display: 'flex', gap: 8, justifyContent: 'flex-end' }}>
          <button className="zivo-global-modal-button" onClick={onClose} type="button">
            OK
          </button>
        </div>
      </div>
    </div>
  );
};

export default AlertModal;
